export class ContentItemAccount implements IContentItemAccount {
  id?: string;
  dateCreated?: Date;
  dateUpdated?: Date;
  createdByPersonId?: string | undefined;
  updatedByPersonId?: string | undefined;
  contentItemId?: string;
  accountId?: string;

  constructor(data?: IContentItemAccount) {
    if (data) {
      for (const property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data['id'];
      this.dateCreated = _data['dateCreated'] ? new Date(_data['dateCreated'].toString()) : <any>undefined;
      this.dateUpdated = _data['dateUpdated'] ? new Date(_data['dateUpdated'].toString()) : <any>undefined;
      this.createdByPersonId = _data['createdByPersonId'];
      this.updatedByPersonId = _data['updatedByPersonId'];
      this.contentItemId = _data['contentItemId'];
      this.accountId = _data['accountId'];
    }
  }

  static fromJS(data: any): ContentItemAccount {
    data = typeof data === 'object' ? data : {};
    const result = new ContentItemAccount();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['id'] = this.id;
    data['dateCreated'] = this.dateCreated ? this.dateCreated.toISOString() : <any>undefined;
    data['dateUpdated'] = this.dateUpdated ? this.dateUpdated.toISOString() : <any>undefined;
    data['createdByPersonId'] = this.createdByPersonId;
    data['updatedByPersonId'] = this.updatedByPersonId;
    data['contentItemId'] = this.contentItemId;
    data['accountId'] = this.accountId;
    return data;
  }
}

export interface IContentItemAccount {
  id?: string;
  dateCreated?: Date;
  dateUpdated?: Date;
  createdByPersonId?: string | undefined;
  updatedByPersonId?: string | undefined;
  contentItemId?: string;
  accountId?: string;
}